import { FormControl, Grid, InputLabel, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, Tooltip, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../../services/api";
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addPersonaContacto, removePersonaContacto, setDatoPersonaContacto
    , setPersonaContactos, setTiposContactos, initPersonContact, defaultPersonaContactos } from '../../redux/person/personContactSlice'
import DialogYesNo from '../common/DialogYesNo'
import * as personaService from "../../services/personaService";
import * as catalogoService from "../../services/catalogoService";

const PersonContact = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const isReadOnly = props.isReadOnly;

    useEffect(() => {
        dispatch(initPersonContact({ sliceKey }));
    }, [dispatch, sliceKey]);

    const personaContactos = useSelector((state) => state.personContact[sliceKey]?.personaContactos);
    const tiposContactos = useSelector((state) => state.personContact[sliceKey]?.tiposContactos);
    
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);
    
    const fetchPersonaContactos = useCallback(async () => {
        const response = await personaService.getsPersonaContactoView(props.id)

        if (response == null || response.length == 0)
            dispatch(setPersonaContactos({sliceKey: sliceKey, data: defaultPersonaContactos}))
        else
            dispatch(setPersonaContactos({sliceKey: sliceKey, data: response}))
    }, [])
    const fetchTiposContactos = useCallback(async () => {
        const response = await catalogoService.getCatalogosByPadre(12)
        dispatch(setTiposContactos({sliceKey: sliceKey, data: response}));
    }, [])

    useEffect(() => {
        fetchPersonaContactos();
        fetchTiposContactos();
    }, [])

    const deletePersonaContacto = async () => {
        await personaService.deletePersonaContacto(props.id, selectNumero)
        dispatch(removePersonaContacto({sliceKey: sliceKey, numero: selectNumero}));
    }
    const setItemValue = (numero, name, value) => {
        dispatch(setDatoPersonaContacto({sliceKey: sliceKey, numero: numero, name: name, value: value}))
    }

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Datos de Contacto (" + (personaContactos?.length || 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <Tooltip title={"Agregar Dato de Contacto"}>
                    <IconButton size="small" aria-label="agregar" style={{height: 10}} disabled={isReadOnly} onClick={() => {
                        dispatch(addPersonaContacto(sliceKey));
                    }}>
                        <IconAddCircle />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid container>
                <Table size="small">
                    <TableBody>
                        {personaContactos?.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell>
                                    <Grid container spacing={1} padding={0}>
                                        <Grid item xs={8} sm={5}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-tipocontacto">Tipo</InputLabel>
                                                <Select
                                                    native
                                                    label="Tipo"
                                                    value={row.idTipoContacto || 0}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        setItemValue(row.numero, "idTipoContacto", event.target.value);
                                                    }}
                                                    inputProps={{
                                                        name: 'idTipoContacto',
                                                        id: 'input-tipocontacto',
                                                    }}
                                                    size="small"
                                                    disabled={isReadOnly}
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {tiposContactos?.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={10} sm={7}>
                                            <Box display="flex" alignItems="center" gap={0}>
                                                <TextField
                                                    required
                                                    name="valor"
                                                    label="Valor"
                                                    fullWidth
                                                    value={row.valor || ""}
                                                    onChange={(event) => {
                                                        setItemValue(row.numero, "valor", event.target.value);
                                                    }}
                                                    size="small"
                                                    disabled={isReadOnly}
                                                />
                                                <Tooltip title={"Quitar Contacto"} arrow>
                                                    <IconButton aria-label="delete" disabled={isReadOnly} onClick={() => {
                                                        if (row.idPersona > 0) {
                                                            setSelectId(row.id);
                                                            setSelectNumero(row.numero);
                                                            setOpenDialogDelete(true);
                                                        }
                                                        else {
                                                            dispatch(removePersonaContacto({sliceKey: sliceKey, numero: row.numero}));
                                                        }
                                                    }}>
                                                        <IconDelete />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
            <DialogYesNo open={openDialogDelete} openClose={openCloseDialogDelete} setYes={deletePersonaContacto} setNo={() => { return }}
                titulo={"Borrar Contacto"}
                texto={"Esta seguro de borrar el contacto?"} ></DialogYesNo>
        </Grid>
    )
}

export default PersonContact;
